// Insert or update a knowledge-base article. Used by meet's applySuggestion
// when the transcript extraction routes to the `knowledge_base` bucket.
import { getSDK } from '@symbo-ls/workspace-shared/functions/sdk.js'
import { _docContent, _joinBodyText } from './parseBody.js'

export const saveKbArticle = async function ({
  id = null,
  title = 'Untitled article',
  category = 'general',
  summary = '',
  content = ''
} = {}) {
  const root = this.state.root
  const row = {
    title,
    folderPath: 'knowledge-base',
    type: 'doc',
    author: root.currentUserEmail || 'Unknown',
    summary: summary || '',
    body: typeof content === 'string' ? content : ''
  }
  let data = null
  try {
    data =
      id != null
        ? // sdk.execute(from, op, args) is 3-arg; idPayload argMap reads args.id + args.payload.
          // Passing (id, row) as positional args #3/#4 makes args=id and loses row entirely.
          await getSDK().execute('docs', 'update', { id, payload: row })
        : await getSDK().execute('docs', 'create', row)
  } catch (err) {
    console.error('[saveKbArticle] write failed', err?.message || err)
    return null
  }
  const newId = data?.docId || data?._id || data?.id
  if (!newId) {
    console.error('[saveKbArticle] write returned no id')
    return null
  }
  const existing = root.documents || []
  // Frozen content + write-time `_bodyText` — same row shape as the
  // documentsFetch transform, so the DocsGrid card stays identity-stable
  // and its Summary factories stay O(1) (see functions/rowIdentity.js).
  const mergedContent = _docContent(data.body || data.content || row.body)
  const merged = {
    id: newId,
    title: data.title || title,
    folder: data.folderPath || data.folder || 'knowledge-base',
    type: data.type || 'doc',
    author: data.author || '',
    updatedAt: new Date().toISOString().slice(0, 10),
    summary: data.summary || summary,
    _bodyText: _joinBodyText(mergedContent),
    content: mergedContent
  }
  const next = existing.some((r) => r.id === newId)
    ? existing.map((r) => (r.id === newId ? merged : r))
    : [merged, ...existing]
  root.update({ documents: next })
  this.call('forgetDocLists')
  return newId
}
